import HeaderPage from "../../components/lines-managements/header/HeaderPage";
import { RESERVATION_ADD_ON_FILTER } from "../../components/reservation_v2/addOnFilters";
import Reservations from "../../components/reservation_v2/Reservations";

const ReservationsPage = () => {

  return (
    <>
      <HeaderPage
        hasFilter
        filterName="Filtro Rezervimet"
        groups={[
          {
            title: "Statuset",
            filterSelctor: "statusId",
            options: [
              { label: "I konfirmuar", id: "1" },
              { label: "I pa përfunduar", id: "2" },
              { label: "I anuluar", id: "3" },
              { label: "I rimbursuar", id: "4" }
            ]
          },
          {
            title: "Add-ons",
            filterSelctor: RESERVATION_ADD_ON_FILTER.selector,
            multiple: true,
            options: RESERVATION_ADD_ON_FILTER.options
          }
        ]}
      />
      <Reservations />
    </>
  );
};

export default ReservationsPage;
